module.exports = __webpack_public_path__ + "static/media/AB_illustration_flight.c8c98351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_illustration_flight.png
// module id = 1058
// module chunks = 0